import { NavLink } from "react-router-dom";
import { useAuth } from "../../utils/auth";
import '../../css/navStyling.css';

const AdminNav = () => {

    const auth = useAuth();

    return (
        <>
            <nav className="adminNav">
                { (auth.c === 129763 || auth.a === 157416 || auth.s === 185391) &&
                    <>
                        <NavLink to='info'>Admin info</NavLink>
                        <NavLink to='activiteiten'>Activiteiten</NavLink>
                        <NavLink to='aanmeldingen'>Aanmeldingen</NavLink>
                    </>
                }

                { (auth.a === 157416 || auth.s === 185391) &&
                    <NavLink to='gebruikers'>Gebruikers</NavLink>
                }

                { auth.s === 185391 &&
                    <NavLink to='instellingen'>Instellingen</NavLink>
                }
            </nav>
        </>
    );
}

export default AdminNav;